/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GetAllReportOrderResponse = {
    orderNo?: string;
    customerName?: string;
    itemCount?: number;
    paymentMethod?: GetAllReportOrderResponse.paymentMethod;
    subTotal?: number;
    discount?: number;
    total?: number;
    description?: string;
    isCancel?: boolean;
    note?: string;
    createdAt?: string;
    createdByFirstName?: string;
    createdByLastName?: string;
    canceledByFirstName?: string;
    canceledByLastName?: string;
    totalCost?: number;
};
export namespace GetAllReportOrderResponse {
    export enum paymentMethod {
        CASH = 'CASH',
        CREDIT_CARD = 'CREDIT_CARD',
        BANK_TRANSFER = 'BANK_TRANSFER',
        INSTALLMENT = 'INSTALLMENT',
    }
}

